import { render, staticRenderFns } from "./title_and_name.vue?vue&type=template&id=ddf33eca&scoped=true&"
import script from "./title_and_name.vue?vue&type=script&lang=js&"
export * from "./title_and_name.vue?vue&type=script&lang=js&"
import style0 from "./title_and_name.vue?vue&type=style&index=0&id=ddf33eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf33eca",
  null
  
)

export default component.exports